export default "__VITE_ASSET__BkHIohfu__"